/* global Excel */

import { sanitizeTraceReportSheetName } from './sanitize-excel-sheet-name.util';

/**
 * Inserts a new worksheet named from the report display name, activates it, and syncs.
 * The tabular writer uses the active sheet, so subsequent writes land on this sheet.
 */
export async function insertAndActivateTraceWorksheet(reportDisplayName: string): Promise<void> {
    const name = sanitizeTraceReportSheetName(reportDisplayName);
    await Excel.run(async (context) => {
        try {
            const sheet = context.workbook.worksheets.add(name);
            sheet.activate();
            await context.sync();
        } catch {
            const sheet = context.workbook.worksheets.add();
            sheet.activate();
            await context.sync();
        }
    });
}
